import { useState } from 'react';

import styled from '@emotion/styled';
import { CheckIcon, CheckIconVariant } from '@repo/ui/icons';
import { getServiceName } from '@repo/utils';

import { usePostRevenueShareTermsAgreement } from 'services/hooks/user';
import { closeModal } from 'store/modalStackStore';
import { translation } from 'utils/translation';

import { PATH } from 'routers/paths';

// 배포 이전 본인인증·계좌인증 유저가 리워드 진입 시, 수익분배약관 미동의면 노출되는 게이트 모달
export default function RevenueShareTermsAgreementModal() {
  const [agreed, setAgreed] = useState(false);
  const { mutate, isPending } = usePostRevenueShareTermsAgreement();

  const handleConfirm = () => {
    if (!agreed || isPending) return;
    mutate(undefined, { onSuccess: () => closeModal() });
  };

  return (
    <SWrapper>
      <STitleSection>
        <STitle>{translation('chat.rewards_revenue_sharing_terms_agreement_title')}</STitle>
        <SAgreeRow>
          <SCheckLabel>
            <input type="checkbox" checked={agreed} onChange={(e) => setAgreed(e.target.checked)} />
            <CheckIcon variant={agreed ? CheckIconVariant.ON : CheckIconVariant.OFF} size={24} />
          </SCheckLabel>
          <SAgreeText>
            <a href={PATH.POLICY.POLICY_REVENUE} target="_blank" rel="noreferrer">
              {translation('chat.rewards_profit_sharing_terms')}
            </a>
            에 동의합니다.
          </SAgreeText>
        </SAgreeRow>
      </STitleSection>
      <SConfirmButton
        type="button"
        disabled={!agreed || isPending}
        onClick={handleConfirm}
        $isTingle={getServiceName() === 'tingle'}
      >
        확인
      </SConfirmButton>
    </SWrapper>
  );
}

const SWrapper = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  width: 100%;
  padding: 34px 30px 30px;

  @media ${({ theme }) => theme.device.small} {
    width: 320px;
  }
`;

const STitleSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  width: 100%;
`;

const STitle = styled.p`
  ${({ theme }) => theme.font.head6_sb};
  color: ${({ theme }) => theme.color.text.default};
  text-align: center;
`;

const SAgreeRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
`;

const SCheckLabel = styled.label`
  display: flex;
  align-items: center;
  cursor: pointer;

  input {
    display: none;
  }
`;

const SAgreeText = styled.span`
  ${({ theme }) => theme.font.body2_sb};
  color: ${({ theme }) => theme.color.text.TXT_2};

  a {
    color: #138cf2;
    text-decoration: underline;
    text-underline-offset: 2px;
  }
`;

// 팅글 리워드 CTA: yellow/black (임시, 디자인 제안 Figma 1072:58012). 버블챗은 기존 primary/white 유지
const SConfirmButton = styled.button<{ $isTingle?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 12px 0;
  border-radius: 8px;
  background-color: ${({ theme, $isTingle }) => ($isTingle ? theme.color.brand.primary : theme.color.static.primary)};
  color: ${({ theme, $isTingle }) => ($isTingle ? '#000000' : theme.color.static.white)};
  ${({ theme }) => theme.font.body1_m};

  &:disabled {
    background-color: ${({ theme }) => theme.color.buttons.disable};
    color: ${({ theme }) => theme.color.label.primary};
    cursor: default;
  }
`;
